import React, { FC } from 'react';
import { Button } from '@chakra-ui/react';
import { useLiquidityByIchiState } from '@app/state/liquidityByIchiStore';
import { formatWalletAddress } from '@app/helpers/format';

interface Props {
  vaultAddress: string;
}

export const VaultButton: FC<Props> = ({ vaultAddress }) => {
  const {
    vaultId,
    actions: { setVaultId }
  } = useLiquidityByIchiState();

  const isActive = vaultId?.toLowerCase() === vaultAddress.toLowerCase();

  return (
    <Button
      key={vaultAddress}
      variant="tertiary"
      width="fit-content"
      px={10}
      onClick={() => setVaultId(vaultAddress)}
      sx={{
        fontSize: 14,
        color: isActive ? 'orange' : 'gray.4',
        bg: isActive ? 'gray.2' : 'transparent',
        textTransform: 'capitalize'
      }}
    >
      {formatWalletAddress(vaultAddress)}
    </Button>
  );
};
